<template>
  <div :class="[size, 'wrapper', inputDirection]" @click="copyToClipboard">
    <span :class="[inputDirection, 'text', 'input']">{{ inputContent }}</span>
    <a class="copy-btn text">העתק</a>
  </div>
</template>

<script>
export default {
  name: 'InputCopy',
  props: {
    inputContent: {
      type: String,
      required: true,
    },
    inputDirection: {
      type: String,
      default: 'ltr',
      validate: val => ['ltr', 'rtl'].includes(val),
    },
    size: {
      type: String,
      default: 'slim',
      validator: val => ['slim'].includes(val),
    },
  },
  methods: {
    async copyToClipboard() {
      try {
        await this.$copyText(this.inputContent);
        this.$emit('copied');
      } catch (e) {
        this.$emit('copyFailed', e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/riseup-colors';
@import '../scss/border-radius';

.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;

  padding: 19px 18px;
  border: 1px solid $riseup_black;

  text-align: center;
  background-color: $riseup_white;
  border-radius: $input-field-border-radius;
  cursor: pointer;

  &.slim {
    height: 54px;
  }

  .copy-btn {
    font-weight: bold;
    user-select: none;
  }

  .text {
    font-size: 16px;
    line-height: 16px;
  }

  .input {
    flex-grow: 1;
    border: none;
    background-color: transparent;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    text-overflow: ellipsis;

    &.ltr {
      direction: ltr;
    }

    &.rtl {
      direction: rtl;
    }
  }
}

</style>
